import { Row } from "../types";

export function validateEmail(email: Row["email"]): Promise<boolean> {
  return new Promise<any>((resolve) => {
    const emailRegex = new RegExp(
      /^[A-Za-z0-9._+\-"]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "i"
    );

    const isValid = !emailRegex.test(email);
    resolve(isValid ? `Wrong email.` : null);
  });
}

export function validatePassword(
  password: Row["password"],
  isNew: Row["isNew"]
): Promise<boolean> {
  return new Promise<any>((resolve) => {
    const isNewValid = isNew && password.trim().length < 8;
    const isValid = password.length && password.trim().length < 8;
    return resolve(isValid || isNewValid ? `Wrong password.` : null);
  });
}
